import React from "react"
import { useTranslation } from "react-i18next"

import { Content, Description } from "pages/static/elements"
import Title from "components/ui/Title"

const BadRequest = () => {
  const { t } = useTranslation()

  return (
    <Content data-testid="bad-request-page">
      <Title>{t("pages.bad_request.title")}</Title>
      <Description>{t("pages.bad_request.description")}</Description>
    </Content>
  )
}

export default BadRequest
